<template>
  <v-app :style="appStyle">
    <!-- Loading Widget -->
    <LoadingSpinner
      :is-loading="enableLoader"
      class="loading-spinner"
    />
    <v-main>
      <v-container
        v-if="!enableLoader && !(language && privacy)"
        fluid
        class="fill-height"
        :class="{
          'px-0': privacy,
          'py-0': privacy
        }"
      >
        <!-- LANDING PAGE ( Privacy + Optional Code ) -->
        <Toast position="ne" />
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="6"
            lg="5"
            xl="3"
          >
            <SecurityCodeDialog
              v-if="showSecurityCodeDialog"
              :security-code="securityCode"
              @send-security-code="onSendSecurityCode"
            />
            <v-card
              v-if="!showSecurityCodeDialog"
              class="elevation-12"
            >
              <v-card-title
                color="default"
                flat
                class="justify-center pt-12"
              >
                <div>
                  <v-img
                    :src="getPopupLogoImage"
                    alt="intimissimi"
                  />
                </div>
              </v-card-title>
              <v-card-text>
                <LanguageSelection v-if="!language" />
                <PolicyComponent
                  v-if="language"
                  :language="language"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- STREAMING PAGE -->
      <v-container v-else
                   fluid
                   class="fill-height  px-0 py-0"
      >
        <StreamingView
          v-if="language && privacy"
          :language="language"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Toast, } from 'vuex-toast';
import { mapGetters, } from 'vuex';
import LanguageSelection from '@/components/LanguageSelection';
import StreamingView from '@/views/StreamingView';
import PolicyComponent from '@/components/PolicyComponent';
import LoadingSpinner from '@/components/LoadingSpinner';
import SecurityCodeDialog from '@/components/SecurityCodeDialog';
import { ERROR_EVENT_COMING_SOON, INFO_EVENT_PROTECTED, DEFAULT_STYLE } from '@/constants';

import { mapActions, } from 'vuex';

export default {
  name: 'App',

  components: {
    PolicyComponent,
    StreamingView,
    LanguageSelection,
    Toast,
    LoadingSpinner,
    SecurityCodeDialog
  },
  data: () => ({
    codeMatch: true,
    securityCode: '',
    showSecurityCodeDialog: false,
    enableLoader: true,
    bgSize: '',
    appStyle: {
      'text-align': 'center'
    }
  }),
  computed: {
    ...mapGetters([
      'language',
      'privacy',
      'style',
      'comingSoonUrl',
      'notFoundUrl',
      'backgroundImage',
      'popupLogoImage',
      'securityCodeMatch',
      'mode',
    ],),
    getPopupLogoImage() {
      return this.popupLogoImage;
    },
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search,);
    this.fetchMetadataEvent(urlParams.get('eventId',),)
      .then((result,) => {
        this.updateStyle();
        if (result === INFO_EVENT_PROTECTED) {
          this.showSecurityCodeDialog = true;
          this.enableLoader = false;
        } else {
          this.handleFetchChannelsEvent();
        }
      },)
      .catch((error,) => {
        if (error === ERROR_EVENT_COMING_SOON) {
          window.location.replace(this.comingSoonUrl,);
        } else {
          window.location.replace(this.notFoundUrl,);
        }
      },);
  },

  methods: {
    ...mapActions(['fetchMetadataEvent', 'fetchChannelsEvent', 'setSecurityCodeMatch',],),

    onSendSecurityCode (securityCode,) {
      this.handleFetchChannelsEvent(securityCode,);
    },

    async handleFetchChannelsEvent(securityCode,) {
      var urlParams = new URLSearchParams(window.location.search,);
      const eventId = urlParams.get('eventId',);

      this.fetchChannelsEvent({eventId, securityCode,},)
        .then(() => {
          this.showSecurityCodeDialog = false;
          this.enableLoader = false;
        },)
        .catch((error,) => {
          if (error === ERROR_EVENT_COMING_SOON) {
            window.location.replace(this.comingSoonUrl,);
          }
          this.setSecurityCodeMatch(false,);
        },);
    },

    updateStyle() {
      this.$vuetify.theme.themes.light.primary = this.style.passwordColor;
      this.appStyle = DEFAULT_STYLE;
      this.appStyle['background-color'] = this.style && this.style.backgroundColor ? 
        this.style.backgroundColor : '#000';
      this.appStyle['background-image'] = `url(${this.backgroundImage})`;
      this.appStyle['--button-text-color'] =
            this.style && this.style.buttonTextColor
              ? this.style.buttonTextColor
              : '#fff';
      this.appStyle['--button-text-color'] =
            this.style && this.style.buttonTextColor
              ? this.style.buttonTextColor
              : '#fff';
      this.appStyle['--button-text-font-size']=
            this.style && this.style.buttonTextFontSize
              ? this.style.buttonTextFontSize
              : '18px';
      this.appStyle['--button-background-color']=
            this.style && this.style.buttonBackgroundColor
              ? this.style.buttonBackgroundColor
              : '#000';
      this.appStyle['--button-hover-text-color']=
            this.style && this.style.buttonHoverTextColor
              ? this.style.buttonHoverTextColor
              : '#000';
      this.appStyle['--button-hover-background-color']=
            this.style && this.style.buttonHoverBackgroundColor
              ? this.style.buttonHoverBackgroundColor
              : '#fff';
      this.appStyle['--popup-background-color']=
            this.style && this.style.popupBackgroundColor
              ? this.style.popupBackgroundColor
              : '#fff';
      this.appStyle['--text-color']=
            this.style && this.style.textColor ? this.style.textColor : '#000';
      this.appStyle['--font-family']=this.style && this.style.fontFamily ? this.style.fontFamily : 'roboto';
      this.appStyle['font-family'] = this.style && this.style.fontFamily ? this.style.fontFamily : 'roboto';
      this.appStyle['--font-size']=
            this.style && this.style.fontSize ? this.style.fontSize : '18px';
    }
  },
};
</script>

<style style="scss">
  @import "./scss/variables.scss";

  .no-drag {
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

</style>

<style scoped>

</style>
